import { Box, Button, Typography } from '@material-ui/core';
import { generatePDF } from '../common';
import { DocumentTempPrint } from '../Sections/generator/print/DocumentTempPrint';
import MyIcon from './MyIcon';

// Approval Status Constants
const APPROVAL_STATUS = {
  PENDING: 0,
  MANAGER_APPROVED: 1,
  ACCOUNTANT_APPROVED: 2,
  FULLY_APPROVED: 3,
  REJECTED: -1,
};

export default function PrintDownload({
  company,
  printData,
  template,
  componentRef,
  handleReactPrint,
  isRTL,
  no,
  element,
  isNew,
  approvalStatus,
}: any) {
  const isApproved =
    approvalStatus === undefined ||
    approvalStatus === APPROVAL_STATUS.MANAGER_APPROVED ||
    approvalStatus === APPROVAL_STATUS.ACCOUNTANT_APPROVED ||
    approvalStatus === APPROVAL_STATUS.FULLY_APPROVED;

  return (
    <Box
      style={{
        margin: 10,
        padding: 10,
        borderRadius: 10,
        display: 'flex',
      }}
    >
      <Box
        style={{
          display: isNew ? 'none' : 'flex',
          flex: 1,
          alignItems: 'center',
          justifyContent: 'center',
          marginLeft: 20,
          marginRight: 20,
        }}
      >
        {isApproved ? (
          <>
            <Button
              variant="text"
              endIcon={<MyIcon icon="print" size={20} />}
              onClick={handleReactPrint}
              style={{ marginLeft: 10, marginRight: 10 }}
            >
              {isRTL ? 'طباعة' : 'Print'}
            </Button>
            <Button
              onClick={() => generatePDF({ no, template, element })}
              variant="text"
              endIcon={<MyIcon icon="pdf" size={20} />}
              style={{ marginLeft: 10, marginRight: 10 }}
            >
              {isRTL ? 'تحميل' : 'Download'}
            </Button>
          </>
        ) : (
          <Typography
            variant="body2"
            style={{
              color: '#ff9800',
              fontWeight: 'bold',
              textAlign: 'center',
            }}
          >
            {isRTL
              ? 'يتطلب اعتماد قبل الطباعة'
              : 'Requires approval before printing'}
          </Typography>
        )}
      </Box>
      <div
        id={element}
        style={{
          position: 'absolute',
          left: '-999em',
          direction: 'ltr',
          width:
            template?.size === 'POS'
              ? '80mm'
              : template?.size === 'A5'
                ? '148mm'
                : '210mm',
        }}
      >
        <DocumentTempPrint
          company={company}
          data={printData}
          template={template}
          ref={componentRef}
          isRTL={isRTL}
        ></DocumentTempPrint>
      </div>
    </Box>
  );
}
